import React from "react";
import PlayerBanner from "./header/PlayerBanner";
import PlayerHeader from "./header/PlayerHeader";

export default function(props) {
  const { 
    showBanner, 
    headerData, 
    bannerAvatarData, 
    creator,
    mainPage,
    premiumLogged
  } = props;
  
  return (
    <>
      {showBanner && <PlayerBanner data={bannerAvatarData} />}
      <PlayerHeader 
        data={headerData} 
        creator={creator} 
        mainPage={mainPage}
        premiumLogged={premiumLogged} 
      />
    </>
  );
}
